export default __webpack_public_path__ + "static/media/Lysithea.3e2f62e7.svg";